import Route from '@ember/routing/route';

interface LocationOverviewPoliciesEditParams {
  policy_id: string;
}

export default class LocationOverviewPoliciesEditRoute extends Route {
  titleToken = 'Update Policy';

  model(params: LocationOverviewPoliciesEditParams): string {
    return params.policy_id;
  }
}
